import { SaleTypeForPlan } from "@/lib/gql/__generated__/graphql";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import type { ProductRoomFormModel } from "../type";

type Props = {
	hotelID: string;
	roomID: string;
	queryData: ProductRoomFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_ROOM_INPUT_MODEL = ({ hotelID, roomID, queryData }: Props) => {
	const { hotelPolicy } = queryData;

	const requiredPrepMillisecond = hotelPolicy.requiredPrepMillisecond ?? 0;
	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductRoomFormModel["InputModel"] = {
		hotelID,
		roomID,
		availablePlanIDs: [],

		name: "",

		address: {
			city: "",
			nationality: "",
			other: "",
			postalCode: "",
			pref: "",
			state: "",
			town: "",
		},
		beds: [],
		capacityAdultMaximum: 1,
		capacityKidsMaximum: 0,
		capacityPeopleMaximum: 1,
		catchCopy: "",
		description: "",
		geoLocation: undefined,
		inSale: false,
		isDormitoryType: false,
		isShowStockPreview: false,
		isExtendSiteControllerPeopleNum: false,
		isKidsUnavailable: false,
		isNotDiscountTarget: false,
		keyVisuals: [],
		kidsPolicy: undefined,
		mainKeyVisual: { bucket: "", key: "", region: "", mimeType: null, fileName: null },
		maxRoomNum: 1,
		overSiteControllerPeopleNum: null,
		roomSize: 0,
		saleTypeForPlan: SaleTypeForPlan.Ordinary,

		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,

		amenities: hotelPolicy.amenities,
	} satisfies ProductRoomFormModel["InputModel"];

	return inputModel;
};
